import { Routes, Route } from 'react-router-dom';
// @ts-ignore
import Home from './pages/Home';
// @ts-ignore
import Crossword from './pages/CrosswordAdvanced';
// @ts-ignore
import Examples from './pages/Examples';
// @ts-ignore
import Files from './pages/Files';
// @ts-ignore
import Tasks from './pages/Tasks';
// @ts-ignore
import CssAnimationPage from './components/css-animation-playground/CssAnimationPage';
import HomeBackButton from '../../components/HomeBackButton';

export default function ReportApp() {
  return (
    <div className="app-report">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/crossword" element={<Crossword />} />
        <Route path="/examples" element={<Examples />} />
        <Route path="/files" element={<Files />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/playground" element={<CssAnimationPage />} />
      </Routes>
      <HomeBackButton variant="dark" />
    </div>
  );
}
